document.addEventListener('DOMContentLoaded', () => {
  const paginationContainer = document.querySelector('.pagination__nav');
  const advancedSearchForm = document.getElementById('advanced-search-form');
  const clearButton = document.getElementById('clear-advanced-search');
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get("page")) || 1;

  populateFormFromURL();

  function getFormElements() {
    return {
      bookNameEl: document.getElementById('advanced-search-book-name-results'),
      authorEl: document.getElementById('advanced-search-author-results'),
      publishingEl: document.getElementById('advanced-search-publishing-results'),
      collectionEl: document.getElementById('advanced-search-collection-results')
    };
  }

  advancedSearchForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const searchData = getFormData();
    await performAdvancedSearch(searchData, 1);
  });

  clearButton?.addEventListener('click', () => {
    clearForm();
  });

  paginationContainer?.addEventListener('click', async (event) => {
    if (event.target.matches('.pagination__nav-item[data-page]')) {
      event.preventDefault();
      const page = parseInt(event.target.dataset.page);
      const searchData = getFormData();
      await performAdvancedSearch(searchData, page);
    }
  });

  // Initialize search functionality
  showResultsContainer();
  
  const searchData = hasSearchParameters() 
    ? getFormDataFromURL() 
    : getFormData();
  
  const targetPage = hasSearchParameters() ? page : 1;
  performAdvancedSearch(searchData, targetPage);

  function populateFormFromURL() {
    const bookName = urlParams.get('bookName');
    const author = urlParams.get('author');
    const publishing = urlParams.get('publishing');
    const collection = urlParams.get('collection');

    const { bookNameEl, authorEl, publishingEl, collectionEl } = getFormElements();

    if (bookName && bookNameEl) {
      bookNameEl.value = bookName;
    }
    if (author && authorEl) {
      authorEl.value = author;
    }
    if (publishing && publishingEl) {
      publishingEl.value = publishing;
    }
    if (collection && collectionEl) {
      collectionEl.value = collection;
    }
  }

  function getFormData() {
    const { bookNameEl, authorEl, publishingEl, collectionEl } = getFormElements();
    const additionalTermFromURL = urlParams.get('additionalTerm');
    
    return {
      bookName: bookNameEl ? bookNameEl.value.trim() || null : null,
      author: authorEl ? authorEl.value.trim() || null : null,
      publishing: publishingEl ? publishingEl.value.trim() || null : null,
      collection: collectionEl ? collectionEl.value.trim() || null : null,
      additionalTerm: additionalTermFromURL || null,
      additionalTermType: "keyword"
    };
  }

  function getFormDataFromURL() {
    return {
      bookName: urlParams.get('bookName') || null,
      author: urlParams.get('author') || null,
      publishing: urlParams.get('publishing') || null,
      collection: urlParams.get('collection') || null,
      additionalTerm: urlParams.get('additionalTerm') || null,
      additionalTermType: "keyword"
    };
  }

  function hasSearchParameters() {
    return urlParams.has('bookName') || urlParams.has('author') || urlParams.has('publishing') || 
           urlParams.has('collection') || urlParams.has('additionalTerm');
  }

  function clearForm() {
    const { bookNameEl, authorEl, publishingEl, collectionEl } = getFormElements();

    if (bookNameEl) {
      bookNameEl.value = '';
    }
    if (authorEl) {
      authorEl.value = '';
    }
    if (publishingEl) {
      publishingEl.value = '';
    }
    if (collectionEl) {
      collectionEl.value = '';
    }
  }

  function performAdvancedSearch(searchData, page) {
    updateURLWithSearchParams(searchData, page);
    showLoadingState();
    fetchAdvancedSearchResults(searchData, page);
  }

  function updateURLWithSearchParams(searchData, page) {
    const url = new URL('/pages/advanced-search', window.location.origin);
    
    Object.keys(searchData).forEach(key => {
      if (searchData[key] && key !== 'additionalTermType') {
        url.searchParams.set(key, searchData[key]);
      }
    });
    
    if (page > 1) {
      url.searchParams.set('page', page);
    }
    
    window.history.replaceState({}, '', url.toString());
  }

  function showLoadingState() {
    const loadingState = document.querySelector('.main-search__loading-state');
    const collectionGrid = document.querySelector('.product-list__inner');
    const facetMain = document.getElementById('facet-main');
    
    if (loadingState) {
      loadingState.style.display = 'flex';
    }
    
    if (collectionGrid) {
      collectionGrid.innerHTML = '';
    }
    
    if (facetMain) {
      facetMain.removeAttribute('hidden');
    }
  }

  function hideLoadingState() {
    const loadingState = document.querySelector('.main-search__loading-state');
    if (loadingState) {
      loadingState.style.display = 'none';
    }
  }

  async function fetchAdvancedSearchResults(searchData, page) {
    try {
      const { domain } = document.getElementById("boa-search-js").dataset;
      
      const isInitialLoad = !hasSearchParameters() && 
                           (!searchData.bookName && !searchData.author && 
                            !searchData.publishing && !searchData.collection && 
                            !searchData.additionalTerm);

      if (isInitialLoad) {
        hideLoadingState();
        return;
      }
      
      const requestData = {
        bookName: isInitialLoad ? "" : searchData.bookName,
        author: searchData.author,
        publishing: searchData.publishing,
        collection: searchData.collection,
        additionalTerm: searchData.additionalTerm,
        additionalTermType: "keyword",
        page: page
      };
      
      const response = await fetch(`${domain}/tools/proxy/api/books/advanced-search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      
      const result = await response.json();
      
      // Show results container
      const facetMain = document.getElementById('facet-main');
      if (facetMain) {
        facetMain.removeAttribute('hidden');
      }
      
      // Update pagination if available
      if (typeof updatePagination === 'function' && result.pagination) {
        updatePagination(result.pagination, result.data || []);
      }
      
      // Update collection grid
      if (typeof updateCollectionGrid === 'function') {
        const collectionGrid = document.querySelector(".product-list__inner");
        if (collectionGrid) {
          const parent = collectionGrid.closest('.main-advanced-search');
          if (parent) {
            parent.classList.remove('shopify-section--main-search');
            parent.classList.add('main-advanced-search');
          }
        }
        updateCollectionGrid(result.data || []);
      } else {
        // Hide loading state only if updateCollectionGrid is not available
        hideLoadingState();
      } 
      
    } catch (error) {
      console.error("Advanced search error:", error);
      hideLoadingState();
      showErrorState();
    }
  }


  function showErrorState() {
    const collectionGrid = document.querySelector('.product-list__inner');
    if (collectionGrid) {
      const errorText = advancedSearchForm?.dataset.errorText;
      collectionGrid.innerHTML = `<div class="error-state">${errorText}</div>`;
    }
  }

  function showResultsContainer() {
    const facetMain = document.getElementById('facet-main');
    if (facetMain) {
      facetMain.removeAttribute('hidden');
    }
  }
});